export const PARCEL_TEMPLATE_HEADER = [
  "FIRSTNAME",
  "LASTNAME",
  "ENTERPRISE",
  "PHONENUMBER",
  "ADDRESS",
  "CITY",
  "SIZE(S-M-L-XL-D)",
  "DESCRIPTION",
  "VALUE",
  "AMOUNTOCOLLECT",
  "CLIENTREFERENCE",
  "ADDITIONALINFOS",
];

export const PRODUCT_TEMPLATE_HEADER = ["NAME", "REFERENCE", "DESCRIPTION", "CATEGORY", "VOLUME", "VALUE", "WEIGHT"];

export const TEMPLATE_URL_EXCEL = "https://paps-file.fra1.digitaloceanspaces.com/Commande_Client_Template.xlsx";
export const TEMPLATE_PRODUCT_URL = "https://paps-utils.fra1.digitaloceanspaces.com/product-tempate-sample.csv";
export const TEMPLATE_PRODUCT_URL_EXCEL = "https://paps-file.fra1.digitaloceanspaces.com/product-tempate-sample.xlsx";
export default PARCEL_TEMPLATE_HEADER;
